export default ".project-reports-filters-row{padding-top:10px;padding-bottom:5px}";